// Русский — translations
export const ru: Record<string, string> = {
  'app.name': 'VolleyBot',
  'app.loading': 'Загрузка…',
  'app.youreAllSet': 'Всё готово!',
  'app.loadingHome': 'Загружаем главную страницу…',

  'nav.home': 'Главная',
  'nav.games': 'Игры',
  'nav.create': 'Создать',
  'nav.profile': 'Профиль',
  'nav.admin': 'Admin',
  'nav.test': 'Тест',
  'status.open': 'Открыта',
  'status.full': 'Заполнена',
  'status.going': 'Идёт',
  'status.cancelled': 'Отменена',
  'status.finished': 'Завершена',

  'welcome.title': 'Добро пожаловать в VolleyBot',
  'welcome.subtitle': 'Выберите свой уровень игры, чтобы начать.',
  'welcome.cta': 'Продолжить',
  'welcome.done.title': 'Всё готово!',
  'welcome.done.subtitle': 'Загружаем главную страницу…',
  'welcome.hello': 'Привет, {name}!',
  'welcome.intro':
    'VolleyBot помогает находить и организовывать волейбольные игры в вашем городе. Настроим ваш профиль за 30 секунд.',
  'welcome.feature.findGames.title': 'Находите игры рядом',
  'welcome.feature.findGames.desc': 'Открытые игры в вашем городе, отфильтрованные по уровню игры.',
  'welcome.feature.join.title': 'Присоединяйтесь одним касанием',
  'welcome.feature.join.desc': 'Видьте, кто играет, делите стоимость корта, получайте напоминания.',
  'welcome.feature.organize.title': 'Организуйте свою игру',
  'welcome.feature.organize.desc': 'Выберите место, время и уровень — пригласите игроков за секунды.',
  'welcome.getStarted': 'Начать',
  'welcome.footNote': 'Это всегда можно изменить в Профиле.',
  'welcome.skill.title': 'Какой у вас уровень игры?',
  'welcome.skill.subtitle':
    'Выберите уровень, который лучше всего описывает вашу игру. Мы подберём вам игры с похожим уровнем.',
  'welcome.skill.cta': 'Продолжить',
  'welcome.skill.saving': 'Сохранение…',

  'skill.LEVEL_1': 'Начинающий',
  'skill.LEVEL_2': 'Начинающий (Любитель)',
  'skill.LEVEL_3': 'Средний',
  'skill.LEVEL_4': 'Продвинутый',
  'skill.LEVEL_5': 'Полупро',
  'skill.LEVEL_6': 'Профессионал',
  'skill.LEVEL_1.desc':
    'Знает правила, но базовые элементы (приём, подача, передача) пока нестабильны.',
  'skill.LEVEL_2.desc': 'Верхняя подача, позиционная защита, простой приём.',
  'skill.LEVEL_3.desc': 'Стабильный приём, уверенные атаки, первые попытки группового блока.',
  'skill.LEVEL_4.desc':
    'Уверенная игра с пасующим, атаки первым темпом, мощные и тактические подачи.',
  'skill.LEVEL_5.desc':
    'Глубокое тактическое понимание, мощные подачи, отработанные комбинации.',
  'skill.LEVEL_6.desc':
    'Бывшие профи, мастера спорта, отличная техника, молниеносная командная работа.',
  'skill.wheelchair': 'Спортсмен на коляске',

  'home.title': 'Главная',
  'home.hello': 'Привет, {name}!',
  'home.botAlerts': 'Уведомления об играх в чате бота',
  'home.botAlertsSub': 'Разрешите сообщения, чтобы изменения игры приходили в этот чат.',
  'home.upcomingGames': 'Предстоящие игры',
  'home.seeAll': 'Все игры',
  'home.noGames': 'Предстоящих игр пока нет',
  'home.findGame': 'Найти игру',
  'home.createGame': 'Создать игру',
  'home.createGameSub': 'Пригласите игроков за секунды',
  'home.pickYourLevel': 'Выберите свой уровень игры',
  'home.pickYourLevelSub': 'Расскажите другим игрокам о вашем уровне, чтобы вас могли подобрать в команду.',
  'home.openGames': 'Открытые игры',
  'home.freeSpots': 'Свободные места',
  'home.allGames': 'Все игры',
  'home.openGamesInCity': '{count} открытых игр в вашем городе.',
  'home.noGamesSub': 'Игр пока нет - создайте первую.',
  'home.emptyCta': 'Создайте первую волейбольную игру в {city}. Нажмите "Создать игру", чтобы начать.',

  'profile.title': 'Профиль',
  'profile.about': 'О вас',
  'profile.age': 'Возраст',
  'profile.city': 'Город',
  'profile.language': 'Язык',
  'profile.bio': 'Кратко о себе (необязательно)',
  'profile.skill': 'Уровень игры',
  'profile.skillFromEvaluations': 'На основе {n} оценок',
  'profile.save': 'Сохранить',
  'profile.saved': 'Профиль сохранён',
  'profile.signOut': 'Выйти',
  'profile.signOutConfirm': 'Выйти из VolleyBot?',
  'profile.adminPanel': 'Админ-панель',
  'profile.blacklist': 'Заблокированные игроки',
  'profile.invitations': 'Приглашения',
  'profile.payments': 'Платежи',
  'profile.status.admin': 'Админ',

  'games.title': 'Игры',
  'games.filter.city': 'Город',
  'games.filter.skill': 'Уровень',
  'games.filter.skillAny': 'Любой уровень',
  'games.filter.bucket.beginner': 'Начинающий',
  'games.filter.bucket.intermediate': 'Средний',
  'games.filter.bucket.advanced': 'Продвинутый',
  'games.filter.dateFrom': 'С',
  'games.filter.dateTo': 'По',
  'games.filter.spots': 'Мест',
  'games.filter.any': 'Любое',
  'games.filter.search': 'Поиск в заметках',
  'games.filter.apply': 'Применить',
  'games.filter.clear': 'Очистить',
  'games.filter.quick.all': 'Все',
  'games.filter.quick.open': 'Открытые',
  'games.filter.quick.today': 'Сегодня',
  'games.filter.quick.free': 'Бесплатные',
  'games.filter.quick.indoor': 'Зал',
  'profile.editProfile': 'Редактировать профиль',
  'profile.doneEditing': 'Готово',
  'profile.activity': 'Активность',
  'profile.gamesHosted': 'Игр создано',
  'profile.gamesJoined': 'Игр сыграно',
  'games.empty': 'Игр по вашим фильтрам не найдено.',

  'game.spots': '{count} / {total} мест',
  'game.spotsFull': 'Все занято',
  'game.waitlistNotify': 'Уведомить меня',
  'game.waitlistSubscribed': 'Слежу',
  'game.waitlistStop': 'Стоп',
  'game.waitlistHint': 'Пришлём сообщение в Telegram, когда кто-то выйдет.',
  'game.waitlistToast': 'Ок — напишем в Telegram, если освободится место.',
  'game.waitlistToastOff': 'Больше не следим за этой игрой.',
  'game.changeTime': 'Изменить время',
  'game.changeTimeTitle': 'Перенести игру',
  'game.changeTimeHint': 'Игроки в составе получат уведомление в Telegram с новым временем.',
  'game.changeTimeSave': 'Сохранить новое время',
  'game.changeTimeCurrent': 'Сейчас: {when}',
  'game.changeTimeInvalid': 'Выберите время в будущем.',
  'game.changeTimeSame': 'Это то же время — менять нечего.',
  'game.changeTimeDone': 'Время обновлено. Игроки уведомлены.',
  'game.edit': 'Редактировать игру',
  'game.editTitle': 'Редактировать игру',
  'game.editHint': 'Измените место, тип, время, уровень, места или цену. Все, кто записался, получат сообщение в Telegram, если хотя бы раз открывали бота.',
  'game.editPriceHint': '0 оставляет игру бесплатной. Большая сумма делится на места.',
  'game.editPriceInvalid': 'Укажите цену или 0, чтобы игра осталась бесплатной.',
  'game.editSave': 'Сохранить',
  'game.editDone': 'Игра обновлена.',
  'game.editNoChanges': 'Ничего не изменено.',
  'game.editAddressRequired': 'Адрес обязателен.',
  'game.editSpotsMin': 'Минимум 2 места.',
  'game.editSpotsBelowRoster': 'Нельзя меньше текущих игроков ({n}).',
  'game.spotsOneLeft': 'Осталось 1 место',
  'game.spotsLeft': 'Осталось {n} мест',
  'game.perPlayer': '{amount} / игрок',
  'game.closed': 'Закрытое лобби',
  'game.closedHint': 'Только по приглашению — отправьте запрос, и организатор одобрит.',
  'game.hidePlayers': 'Скрыть игроков от посторонних',
  'game.hidePlayersHint': 'Кто не в игре, видит состав как Инкогнито. Участники видят всех.',
  'game.playersHiddenBanner': 'Список игроков скрыт, пока вы не присоединитесь.',
  'game.playersHiddenHint': 'Присоединитесь, чтобы увидеть состав',
  'create.field.hidePlayers': 'Скрыть игроков от посторонних',
  'game.paid': 'Платная игра',
  'game.free': 'Бесплатная игра',
  'game.host': 'Организатор',
  'game.perPlayerShort': '/ игрок',
  'game.playersShort': 'игроков',
  'game.playersMore': 'ещё {count}',
  'game.spotsLeftShort': '{count} свободно',
  'game.playType.indoor': 'В зале',
  'game.playType.outdoor': 'На улице',
  'game.playType.beach': 'На пляже',
  'game.join': 'Присоединиться',
  'game.leave': 'Покинуть',
  'game.cancel': 'Отменить игру',
  'game.finish': 'Завершить игру',
  'game.requestToJoin': 'Подать запрос',
  'game.requestPending': 'Запрос отправлен',
  'game.joinRequests': 'Запросы на вход ({n})',
  'game.approveRequest': 'Принять',
  'game.rejectRequest': 'Отклонить',
  'game.finishConfirm': 'Отметить игру как завершённую?',
  'game.cancelConfirm': 'Отменить эту игру?',
  'game.evaluations': 'Оценить игроков',
  'game.managePayments': 'Платежи',
  'game.invitePlayers': 'Пригласить игроков',
  'game.share': 'Поделиться',
  'game.shareHeadline': 'Открытая игра — кто с нами?',
  'game.shareCta': 'Открыть и присоединиться:',
  'game.shareSpots': '{filled}/{total} игроков · {left} свободно',
  'game.shareSpotsFull': '{filled}/{total} игроков · мест нет',
  'game.shareFree': 'Бесплатно',
  'game.shareSkill': 'Уровень {n}',
  'game.shareUnavailable': 'Поделиться пока нельзя — попробуй чуть позже.',
  'game.reserve': 'Забронировать место',
  'game.reserveHint': 'Держит место для того, кто не может записаться сейчас. Остальные видят только «Инкогнито».',
  'game.reserveNote': 'Личная заметка',
  'game.reserveNotePlaceholder': 'Для кого? (видишь только ты)',
  'game.reserveRemove': 'Освободить',
  'game.reservedSpots': 'Бронь ({n})',
  'game.incognito': 'Инкогнито',
  'game.incognitoHint': 'Место занято — ещё не в приложении',

  'gameDetail.players': 'Игроки',
  'gameDetail.noPlayers': 'Игроков ещё нет',
  'gameDetail.address': 'Адрес',
  'gameDetail.startsAt': 'Начало',
  'gameDetail.notes': 'Заметки',
  'gameDetail.cover': 'Фото площадки',
  'gameDetail.roleOrganizer': 'Организатор',
  'gameDetail.rolePlayer': 'Игрок',
  'gameDetail.tagHost': 'ОРГ',
  'gameDetail.tagYou': 'ВЫ',
  'gameDetail.reportAction': 'Пожаловаться',
  'gameDetail.actionsFor': 'Действия для {name}',
  'gameDetail.tabPlayers': 'Игроки',
  'gameDetail.tabInfo': 'Детали',
  'gameDetail.joined': 'В игре',
  'gameDetail.confirmedPlayers': 'Подтверждённые игроки ({n})',
  'gameDetail.pricePerPlayer': 'С игрока',

  'create.title': 'Новая игра',
  'create.subtitle': 'Заполните детали и пригласите игроков',
  'create.field.playType': 'Где будет игра',
  'create.playType.indoor': 'В зале',
  'create.playType.outdoor': 'На улице',
  'create.playType.beach': 'На пляже',
  'create.section.where': 'Где',
  'create.section.when': 'Когда',
  'create.section.who': 'Кто',
  'create.section.cost': 'Стоимость',
  'create.section.notes': 'Заметки',
  'create.section.covers': 'Фото площадки',
  'game.coversTitle': 'Фото площадки',
  'game.coversHint': 'Необязательно — одно фото корта. JPEG/PNG/WebP, до 2 МБ. Сохраняется в профиле для следующей игры.',
  'game.coversAdd': 'Добавить фото',
  'game.coversClear': 'Убрать своё фото',
  'game.coversReuseHint': 'Используем сохранённое фото корта — нажмите, чтобы заменить, или создайте игру как есть.',
  'gameDetail.activityTitle': 'Активность игроков',
  'gameDetail.notifyCount': '{n} нажали «Уведомить меня»',
  'gameDetail.activityEmpty': 'Пока нет входов/выходов.',
  'gameDetail.activityJoined': '«{name}» вошёл в игру · {when}',
  'gameDetail.activityLeft': '«{name}» вышел из игры · {when}',
  'create.field.venue': 'Площадка',
  'create.field.savedPlaces': 'Сохранённые места',
  'create.field.savedPlacesPlaceholder': 'Выберите сохранённое место…',
  'create.field.noSavedPlaces': 'Сохранённых мест пока нет. Адрес сохранится после создания игры.',
  'create.field.placeName': 'Название места',
  'create.field.placeNamePlaceholder': 'например, площадка в парке или школьный зал',
  'create.field.venueAddress': 'Адрес',
  'create.field.venueAddressPlaceholder': 'например, ul. Piekary 17, Poznan',
  'create.field.selectVenue': '— выберите площадку —',
  'create.field.start': 'Начало',
  'create.field.duration': 'Часов',
  'create.field.skill': 'Уровень игры',
  'create.field.spots': 'Всего мест',
  'create.field.unlimited': 'Без ограничения',
  'create.field.totalCost': 'Общая стоимость площадки',
  'create.field.currency': 'Валюта',
  'create.field.addressHint': 'Адрес / место встречи',
  'create.field.addressHintPlaceholder': 'например, боковой вход, парк за торговым центром',
  'create.field.coverPreview': 'Обложка',
  'create.field.coverPreviewHint': 'Подбирается автоматически по типу игры.',
  'create.field.paid': 'Это платная игра',
  'create.paidStatus.on': 'Платная игра — игроки должны оплатить свою часть.',
  'create.paidStatus.off': 'Бесплатная игра — оставьте стоимость 0, чтобы игра была бесплатной.',
  'create.field.noVenues': 'В вашем городе ещё нет площадок. Добавьте во вкладке Игры.',
  'create.field.closed': 'Закрытое лобби (только приглашения)',
  'create.cta': 'Создать игру',
  'create.cta.creating': 'Создаём…',
  'create.cost.auto': 'Авто: {venue} × {hours} ч.',
  'create.cost.custom': 'Вы указали свою стоимость.',
  'create.cost.empty': 'Выберите площадку, чтобы заполнить автоматически.',
  'create.cost.manual': 'Сохранённые места с ценой заполнят стоимость автоматически. Иначе введите её вручную.',
  'create.perPlayer': 'С игрока: {amount}',
  'create.splitBetween': 'Делим на {n} игроков',
  'create.unlimitedHint': 'Без верхнего предела количества игроков',
  'create.venueMax': 'Макс. на площадке: {n} игроков',

  'blacklist.title': 'Заблокированные игроки',
  'blacklist.empty': 'Вы никого не заблокировали.',
  'blacklist.add': 'Заблокировать игрока',
  'blacklist.reason': 'Причина (необязательно)',
  'blacklist.remove': 'Разблокировать',
  'blacklist.maxed': 'Можно заблокировать до 10 человек. Сначала кого-то разблокируйте.',
  'blacklist.warning.title': 'В игре есть заблокированный игрок',
  'blacklist.warning.body': 'Вы заблокировали {name}. Вы уверены, что хотите присоединиться?',
  'blacklist.warning.confirm': 'Присоединиться',
  'blacklist.warning.cancel': 'Отмена',

  'report.title': 'Пожаловаться на игрока',
  'report.reason.toxic': 'Токсичное поведение',
  'report.reason.skipped': 'Не пришёл на игру',
  'report.reason.harassment': 'Домогательства',
  'report.reason.cheating': 'Мошенничество',
  'report.reason.other': 'Другое',
  'report.details': 'Детали (необязательно)',
  'report.submit': 'Отправить жалобу',
  'report.thanks': 'Спасибо — админы рассмотрят жалобу.',

  'eval.title': 'Оценить игроков',
  'eval.subtitle': 'Оцените кого хотите — «Пропустить» рядом с именем, или просто отправьте оценки выбранных.',
  'eval.alreadyRated': 'Уже оценён',
  'eval.skip': 'Пропустить',
  'eval.skipAll': 'Пропустить всех',
  'eval.skipPlayer': 'Пропустить',
  'eval.skipped': 'Пропущен',
  'eval.undoSkip': 'Оценить',
  'eval.done': 'Готово',
  'eval.levelN': 'Ур. {n}',
  'eval.noPlayers': 'Нет соигроков для оценки.',
  'eval.submit': 'Отправить оценки',
  'eval.thanks': 'Спасибо — ваши оценки сохранены.',

  'invite.title': 'Приглашения',
  'invite.empty': 'Нет новых приглашений.',
  'invite.emptySearch': 'Пока нет игроков — попробуй имя или @username.',
  'invite.accept': 'Принять',
  'invite.decline': 'Отклонить',
  'invite.ignore': 'Игнорировать',
  'invite.invitePlayer': 'Пригласить игрока',
  'invite.bannerTitle': 'У вас новое приглашение на игру',
  'invite.openGame': 'Открыть игру',
  'invite.invited': 'Приглашение отправлено',
  'invite.invitedTo': 'Приглашение отправлено: {name}',
  'invite.inviteFailed': 'Не удалось пригласить {name}',
  'invite.searchPlaceholder': 'Поиск по имени или @username',
  'invite.noResults': 'По вашему запросу игроков не найдено',
  'invite.inviteAction': 'Пригласить {name}',
  'invite.notifyAria': '{count} ожидающих приглашений',
  'invite.sentTitle': 'Отправленные',
  'invite.statusSent': 'Отправлено',
  'invite.statusRead': 'Прочитано',
  'invite.statusAccepted': 'Принято',
  'invite.statusDeclined': 'Отклонено',
  'invite.statusIgnored': 'Игнорировано',
  'invite.statusInactive': 'Неактивно',
  'invite.resend': 'Ещё раз',
  'invite.resendAria': 'Отправить приглашение снова: {name}',
  'invite.resentTo': 'Приглашение отправлено снова: {name}',

  'payments.title': 'Платежи',
  'payments.totalCost': 'Общая стоимость',
  'payments.perPlayer': 'С игрока',
  'payments.collected': 'Собрано',
  'payments.cashCollected': 'Собрано наличными',
  'payments.methodHint': 'Нажмите $ (наличные) или карту (банк). Только один вариант. Повторное нажатие снимает отметку.',
  'payments.cashHint': 'Нажмите кнопку наличных, когда игрок заплатил вам наличными на площадке.',
  'payments.players': 'Игроки',
  'payments.status': 'Статус',
  'payments.paid': 'Оплачено',
  'payments.paidCash': 'Наличные',
  'payments.paidBank': 'Банк',
  'payments.unpaid': 'Не оплачено',
  'payments.markPaid': 'Отметить оплаченным',
  'payments.markPaidCash': 'Отметить оплаченным наличными',
  'payments.markPaidBank': 'Отметить оплаченным переводом',
  'payments.markUnpaid': 'Отметить неоплаченным',
  'payments.myUnpaid': 'Вы должны {amount} за {venue}',

  'calendar.title': 'Календарь',
  'calendar.today': 'Сегодня',
  'calendar.upcoming': 'Предстоящие',
  'calendar.past': 'Прошедшие',

  'lang.title': 'Язык',
  'lang.uk': 'Українська',
  'lang.pl': 'Polski',
  'lang.en': 'English',
  'lang.ru': 'Москальска',

  'auth.banned.title': 'Вы заблокированы',
  'auth.banned.body': 'Причина: {reason}',
  'auth.banned.contact': 'Свяжитесь с поддержкой, если считаете это ошибкой.',

  'common.cancel': 'Отмена',
  'common.save': 'Сохранить',
  'common.delete': 'Удалить',
  'common.confirm': 'Подтвердить',
  'common.search': 'Поиск',
  'common.loading': 'Загрузка…',
  'common.retry': 'Повторить',
  'common.error': 'Что-то пошло не так',
  'common.close': 'Закрыть',
  'common.back': 'Назад',
  'common.optional': 'Необязательно',
  'common.you': 'Вы',

  'userProfile.view': 'Смотреть профиль',
  'userProfile.viewNamed': 'Профиль игрока {name}',
  'userProfile.openTelegram': 'Открыть в Telegram',
  'userProfile.message': 'Написать в Telegram',
  'userProfile.block': 'Заблокировать',
  'userProfile.blockConfirm': 'Заблокировать {name}? Игрок не будет появляться в ваших подсказках.',
  'userProfile.notFound': 'Игрок не найден',
  'userProfile.notFoundText': 'Этот профиль удалён или недоступен.',

  'banner.signOut': 'Вы вышли.',
  'banner.saved': 'Сохранено.',
  'banner.deleted': 'Удалено.',

  'admin.title': 'Админ-панель',
  'admin.subtitle': 'Управляйте пользователями, играми, жалобами и сохранёнными местами.',
  'admin.subtitleSection': 'Админ · {section}',
  'admin.users': 'Пользователи',
  'admin.activity': 'Использование приложения',
  'admin.games': 'Игры',
  'admin.venues': 'Площадки',
  'admin.reports': 'Жалобы',
  'admin.ratings': 'Выставленные оценки',
  'admin.fb': 'FB',
  'admin.audit': 'Аудит',
  'admin.heatmap': 'Тепловая карта',
  'admin.stats': 'Статистика',
  'admin.search': 'Поиск…',
  'admin.ban': 'Заблокировать',
  'admin.unban': 'Разблокировать',
  'admin.banReason': 'Причина блокировки',
  'admin.userDetails': 'Данные пользователя',
  'admin.userSkill': 'Уровень навыка',
  'admin.userSkillHint': 'Задайте балл на бейдже. Блокировка не даёт оценкам игроков его менять.',
  'admin.userSkillSave': 'Сохранить балл',
  'admin.userSkillSaved': 'Балл сохранён.',
  'admin.userSkillClear': 'Очистить балл',
  'admin.userSkillLock': 'Заблокировать от оценок игроков',
  'admin.userWheelchair': 'Показывать иконку коляски вместо числа',
  'admin.userActivity': 'Активность',
  'admin.appUsage': 'Использование приложения',
  'admin.stat.visited': 'Посетил',
  'admin.stat.cancelled': 'Отменил',
  'admin.stat.created': 'Создал',
  'admin.stat.sessionsPerWeek': 'Сессий / нед',
  'admin.stat.entriesDay': 'Входов / день',
  'admin.stat.entriesWeek': 'Входов / неделю',
  'admin.stat.entriesMonth': 'Входов / месяц',
  'admin.stat.avgTimeInApp': 'Ср. время в приложении',
  'admin.stat.lastActive': 'Последняя активность',
  'admin.stat.evalGiven': 'Оценок выставлено',
  'admin.stat.evalReceived': 'Оценок получено',
  'admin.stat.reportsAgainst': 'Жалоб на пользователя',
  'admin.stat.paymentsMade': 'Платежей сделано',
  'admin.stat.evaluatedSkill': 'Оценённый уровень',
  'admin.bannedWithReason': 'Заблокирован: {reason}',
  'admin.roleAdmin': 'Админ',
  'admin.badgeBanned': 'Заблокирован',
  'admin.filterBanned': 'Заблокированные',
  'admin.filterActive': 'Активные',
  'admin.deleteUser': 'Удалить пользователя',
  'admin.deleteUserConfirm': 'Удалить пользователя {name}? Это нельзя отменить.',
  'admin.cancelGame': 'Отменить игру',
  'admin.resolve': 'Отметить рассмотренной',
  'admin.dismiss': 'Отклонить',
  'admin.resolveAndBan': 'Рассмотрено + бан',
  'admin.index.stats': 'Пользователи, игры, места и регистрации',
  'admin.index.users': 'Управляйте ролями, банами и активностью',
  'admin.index.activity': 'Входы и время в приложении для каждого пользователя',
  'admin.index.games': 'Отменяйте, завершайте или проверяйте любую игру',
  'admin.index.venues': 'Просматривайте сохранённые места, используемые в играх',
  'admin.index.reports': 'Просматривайте и решайте жалобы',
  'admin.index.ratings': 'Точные оценки, которые игрок поставил другим',
  'admin.ratingsSearch': 'Найти игрока…',
  'admin.ratingsPick': 'Найдите игрока, чтобы увидеть оценки, которые он поставил.',
  'admin.ratingsFrom': 'Оценки, которые поставил этот игрок',
  'admin.ratingsEmpty': 'Этот игрок ещё никого не оценивал.',
  'admin.ratingsCount': '{n} оценок',
  'admin.index.fb': 'Волейбольные объявления из группы Facebook за эту неделю',
  'admin.fbHint': 'Вставьте посты за эту неделю. Несколько постов разделите строкой, на которой только ---. Komplet, Komplekt или Full значит, что игра полная. «przy komplecie» — это цена, а не полная игра.',
  'admin.fbGroup': 'Открыть группу Facebook',
  'admin.fbPaste': 'Текст поста',
  'admin.fbLink': 'Ссылка (необязательно)',
  'admin.fbAdd': 'Добавить на доску',
  'admin.fbEmpty': 'На этой неделе на доске нет объявлений.',
  'admin.fbStatus': 'Статус',
  'admin.fbDate': 'Дата',
  'admin.fbLevel': 'Уровень',
  'admin.fbPlaces': 'Свободные места',
  'admin.fbAddress': 'Адрес',
  'admin.fbPostLink': 'Ссылка',
  'admin.fbOpen': 'Есть места',
  'admin.fbFull': 'Полная',
  'admin.fbDelete': 'Удалить',
  'admin.fbRaw': 'Исходный пост',
  'admin.fbAdded': 'Добавлено {n}',
  'admin.fbMissing': '—',
  'admin.activityEmpty': 'Нет пользователей по вашему поиску.',
  'admin.activityShowing': 'Показано {shown} из {total}',
  'admin.stat.entriesDayShort': 'День',
  'admin.stat.entriesWeekShort': 'Неделя',
  'admin.stat.entriesMonthShort': 'Месяц',
  'admin.stat.avgTimeShort': 'Ср. время',
  'admin.stat.neverActive': 'Никогда не открывал приложение',
  'admin.stat.activeJustNow': 'Активен только что',
  'admin.stat.activeMinutesAgo': 'Активен {n} мин назад',
  'admin.stat.activeHoursAgo': 'Активен {n} ч назад',
  'admin.stat.dau': 'DAU',
  'admin.stat.wau': 'WAU',
  'admin.stat.mau': 'MAU',
  'admin.stat.sessionsToday': 'Сессий сегодня',
  'admin.stat.avgSession': 'Ср. сессия',
  'admin.stat.signups24h': 'Регистрации (24ч)',
  'admin.stat.finishedGames': 'Завершённые игры',
  'admin.stat.topScreens': 'Топ экранов (7д)',
  'admin.stat.topActions': 'Топ действий (7д)',
  'admin.stat.topClicks': 'Топ кликов (7д)',
  'admin.stat.platforms': 'Платформы (7д)',
  'admin.stat.languages': 'Языки (7д)',
  'admin.stat.rankEmpty': 'Пока нет данных — пользуйтесь приложением.',
  'admin.index.heatmap': 'Где пользователи нажимают на экранах',
  'admin.heatmapFilter': 'Фильтр по пути экрана…',
  'admin.heatmapEmpty': 'Пока нет кликов.',
  'admin.heatmapAvgPos': 'ср. тап ({x}, {y})',
  'venue.indoor': 'В помещении',
  'venue.outdoor': 'На улице',

  'error.network': 'Ошибка сети. Попробуйте ещё раз.',
  'error.unauthorized': 'Войдите снова.',
  'error.forbidden': 'У вас нет разрешения.',
  'error.notFound': 'Не найдено.',
  'error.tooLarge': 'Файл слишком большой.',
  'error.unknown': 'Что-то пошло не так.',

  'empty.notSignedIn': 'Вы не вошли',
  'empty.notSignedInText': 'Откройте мини-приложение из Telegram, чтобы настроить профиль.',

  'onboarding.chooseLevel': 'Выберите свой уровень',
  'onboarding.levelPrompt': 'Выберите уровень, который лучше всего вас описывает. Другие игроки используют это для подбора игр.',

  'city.default': 'Город по умолчанию',

  'msg.profileUpdated': 'Профиль обновлён',
  'msg.gameCreated': 'Игра создана',
  'msg.gameCancelled': 'Игра отменена',
  'msg.gameLeft': 'Вы покинули игру',
  'msg.gameJoined': 'Вы присоединились к игре',
  'msg.blacklistAdded': 'Игрок заблокирован',
  'msg.blacklistRemoved': 'Игрок разблокирован',
  'msg.reportSubmitted': 'Жалоба отправлена',
  'msg.evaluationsSubmitted': 'Оценки сохранены',
  'msg.invitationResponded': 'Приглашение обновлено',
  'msg.paymentUpdated': 'Платёж обновлён',
  'msg.languageUpdated': 'Язык обновлён',
  'msg.locationUpdated': 'Локация обновлена',
  'msg.signOutDone': 'Вы вышли',

  // ===== Weighted skill level feature =====
  'welcome.changeMode.title': 'Изменить уровень игры',
  'welcome.changeMode.subtitle':
    'Выберите уровень, который лучше всего описывает вашу игру сейчас. Это повлияет на рекомендации матчей.',
  'welcome.changeMode.cta': 'Сохранить уровень',
  'welcome.changeMode.successTitle': 'Уровень обновлён',
  'welcome.changeMode.successSub':
    'Новый уровень сохранён. Он будет применён к будущим матчам.',
  'home.tapToChangeLevel': 'Нажмите, чтобы изменить уровень игры',
  'home.ratePlayers': 'Оцените игроков',
  'home.ratePlayersSub': 'Помогите скорректировать уровни после последней игры',
  'profile.tapToChangeLevel': 'Нажмите, чтобы изменить уровень игры',
  'eval.looksRight': 'Всё верно · Уровень {n}',
  'eval.suggestDifferent': 'Предложить другой уровень',
};
